/**
 * Datos de noticias del Colegio Bertolt Brecht
 * Array de noticias que se puede ir actualizando
 */

export const NEWS_DATA = [
    {
        id: 1,
        title: 'Inauguración del Nuevo Laboratorio de Ciencias',
        slug: 'inauguracion-laboratorio-ciencias',
        date: '2024-11-15',
        category: 'Infraestructura',
        excerpt: 'Estamos emocionados de anunciar la apertura de nuestro nuevo laboratorio de ciencias equipado con tecnología de última generación para potenciar el aprendizaje experimental.',
        content: `El Colegio Bertolt Brecht ha inaugurado un moderno laboratorio de ciencias que permitirá a nuestros estudiantes realizar experimentos y prácticas con equipamiento de última generación.

Este nuevo espacio cuenta con microscopios digitales, equipos de química y física, y tecnología interactiva que facilitará el aprendizaje práctico de las ciencias.

La inversión en infraestructura refleja nuestro compromiso con la excelencia educativa y el desarrollo integral de nuestros estudiantes.`,
        image: null, // Ruta a la imagen cuando esté disponible
        imageAlt: 'Laboratorio de Ciencias',
        author: 'Dirección Académica',
        featured: true,
    },
    {
        id: 2,
        title: 'Estudiantes Destacan en Competencia Nacional de Matemáticas',
        slug: 'competencia-nacional-matematicas',
        date: '2024-11-10',
        category: 'Logros',
        excerpt: 'Nuestros estudiantes obtuvieron el primer lugar en la competencia nacional de matemáticas, demostrando excelencia académica y dedicación.',
        content: `Con gran orgullo anunciamos que nuestros estudiantes han obtenido el primer lugar en la Competencia Nacional de Matemáticas 2024.

Este logro es resultado del esfuerzo conjunto de estudiantes, docentes y padres de familia, así como de nuestra metodología "Enfocado en el Aprendizaje".

Los estudiantes ganadores recibirán reconocimientos especiales y representarán al colegio en competencias internacionales.`,
        image: null,
        imageAlt: 'Competencia de Matemáticas',
        author: 'Departamento de Matemáticas',
        featured: true,
    },
    {
        id: 3,
        title: 'Nuevo Programa de Intercambio Cultural Internacional',
        slug: 'programa-intercambio-internacional',
        date: '2024-11-05',
        category: 'Programas',
        excerpt: 'Lanzamos un innovador programa de intercambio con instituciones educativas en Europa y América para enriquecer la experiencia educativa.',
        content: `El Colegio Bertolt Brecht se complace en anunciar el lanzamiento de su Programa de Intercambio Cultural Internacional.

Este programa permitirá a nuestros estudiantes de secundaria participar en intercambios educativos con colegios de España, Francia y Chile, promoviendo el aprendizaje intercultural y el desarrollo de competencias globales.

Las inscripciones estarán abiertas a partir del próximo mes para estudiantes de 3ro a 5to de secundaria.`,
        image: null,
        imageAlt: 'Intercambio Internacional',
        author: 'Coordinación Internacional',
        featured: false,
    },
    {
        id: 4,
        title: 'Feria de Ciencias 2024: Innovación y Creatividad',
        slug: 'feria-ciencias-2024',
        date: '2024-11-01',
        category: 'Eventos',
        excerpt: 'Los estudiantes presentaron proyectos innovadores en nuestra feria anual de ciencias, demostrando creatividad y pensamiento científico.',
        content: `La Feria de Ciencias 2024 del Colegio Bertolt Brecht fue un rotundo éxito, con más de 50 proyectos presentados por estudiantes de primaria y secundaria.

Los proyectos abarcaron temas como energías renovables, robótica, biotecnología y medio ambiente, demostrando el alto nivel académico de nuestros estudiantes.

Los tres mejores proyectos fueron premiados y tendrán la oportunidad de participar en la Feria Regional de Ciencias.`,
        image: null,
        imageAlt: 'Feria de Ciencias',
        author: 'Departamento de Ciencias',
        featured: false,
    },
    {
        id: 5,
        title: 'Taller de Robótica: Preparando el Futuro',
        slug: 'taller-robotica',
        date: '2024-10-28',
        category: 'Talleres',
        excerpt: 'Iniciamos un nuevo taller de robótica educativa para desarrollar habilidades tecnológicas en nuestros estudiantes.',
        content: `El Colegio Bertolt Brecht ha incorporado un nuevo Taller de Robótica Educativa como parte de su oferta de actividades extracurriculares.

Este taller está diseñado para estudiantes de primaria y secundaria, donde aprenderán programación, diseño y construcción de robots utilizando kits educativos de última generación.

El taller se realizará dos veces por semana y las inscripciones ya están abiertas.`,
        image: null,
        imageAlt: 'Taller de Robótica',
        author: 'Coordinación de Talleres',
        featured: false,
    },
    {
        id: 6,
        title: 'Celebración del Día del Logro Académico',
        slug: 'dia-logro-academico',
        date: '2024-10-20',
        category: 'Eventos',
        excerpt: 'Reconocimos el esfuerzo y dedicación de nuestros estudiantes destacados en una emotiva ceremonia.',
        content: `El pasado viernes celebramos el Día del Logro Académico, una tradición del Colegio Bertolt Brecht donde reconocemos a los estudiantes que han demostrado excelencia académica y valores institucionales.

Más de 100 estudiantes recibieron reconocimientos por su desempeño sobresaliente en diferentes áreas: académica, deportiva, artística y de valores.

La ceremonia contó con la presencia de padres de familia, docentes y autoridades educativas.`,
        image: null,
        imageAlt: 'Día del Logro',
        author: 'Dirección General',
        featured: false,
    },
    {
        id: 7,
        title: 'Comunicado: Inicio del Año Escolar 2025',
        slug: 'comunicado-inicio-año-2025',
        date: '2024-12-01',
        category: 'Comunicado',
        excerpt: 'Informamos a la comunidad educativa sobre las fechas importantes y disposiciones para el inicio del año escolar 2025.',
        content: `Estimada comunidad educativa:

Nos complace informarles que el año escolar 2025 dará inicio el lunes 4 de marzo de 2025.

Fechas importantes:
- Matrícula: Del 15 de enero al 15 de febrero
- Reunión de padres: 28 de febrero, 6:00 PM
- Inicio de clases: 4 de marzo

Los horarios de atención para matrícula son de lunes a viernes de 8:00 AM a 4:00 PM, y sábados de 9:00 AM a 1:00 PM.

Para más información, comunicarse a los teléfonos 918 049 094 | 956 452 679.

Atentamente,
La Dirección`,
        image: null,
        imageAlt: 'Comunicado Oficial',
        author: 'Dirección General',
        featured: true,
    },
];

/**
 * Obtener noticias destacadas
 */
export const getFeaturedNews = () => {
    return NEWS_DATA.filter(news => news.featured);
};

/**
 * Obtener últimas noticias
 * @param {number} limit - Número de noticias a obtener
 */
export const getLatestNews = (limit = 3) => {
    return NEWS_DATA.slice(0, limit);
};

/**
 * Obtener noticia por slug
 * @param {string} slug - Slug de la noticia
 */
export const getNewsBySlug = (slug) => {
    return NEWS_DATA.find(news => news.slug === slug);
};

/**
 * Obtener noticias por categoría
 * @param {string} category - Categoría de la noticia
 */
export const getNewsByCategory = (category) => {
    return NEWS_DATA.filter(news => news.category === category);
};

/**
 * Formatear fecha
 * @param {string} dateString - Fecha en formato YYYY-MM-DD
 */
export const formatNewsDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('es-ES', options);
};
